<template>
  <!--
          作者：gmshop
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <div>
          <el-form-item label="平台">
            <el-select size="small" v-model="formInline.plantform_id" filterable clearable placeholder="请选择平台">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="(item, index) in plantformList" :key="index" :label="item.name" :value="item.plantform_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标签">
            <el-select size="small" v-model="formInline.label_id" filterable clearable placeholder="请选择标签">
              <el-option label="全部" value="0"></el-option>
              <el-option v-for="(item, index) in labelList" :key="index" :label="item.name" :value="item.label_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职业">
            <el-select size="small" v-model="formInline.job_id" filterable clearable placeholder="请选择职业">
              <el-option label="全部" value="0"></el-option>
              <template v-for="item in jobList">
                <el-option :label="item.name" :value="item.job_id"></el-option>
                  <template v-if="item.child !== undefined" v-for="two in item.child">
                      <el-option :value="two.job_id" :key="two.job_id" :label="two.name" style="padding-left: 30px;"></el-option>
                  </template>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="爱好">
            <el-select size="small" v-model="formInline.hobby_id" filterable clearable  placeholder="请选择爱好">
              <el-option label="全部" value="0"></el-option>
              <template v-for="item in hobbyList">
                <el-option :label="item.name" :value="item.hobby_id"></el-option>
                  <template v-if="item.child !== undefined" v-for="two in item.child">
                      <el-option :value="two.hobby_id" :key="two.hobby_id" :label="two.name" style="padding-left: 30px;"></el-option>
                  </template>
              </template>
            </el-select>
          </el-form-item>
        </div>
        <div>
            <el-form-item label="用户ID"><el-input clearable v-model="formInline.user_id" placeholder="用户ID" style="width:120px"></el-input></el-form-item>
            <el-form-item label="渠道ID" v-auth="'/distributor'"><el-input clearable v-model="formInline.distributor_id" placeholder="渠道ID" style="width:120px"></el-input></el-form-item>
            <!-- <el-form-item label="推荐ID"><el-input clearable v-model="formInline.referee_id" placeholder="推荐ID" style="width:120px"></el-input></el-form-item> -->
            <el-form-item label="归属ID" v-auth="'/plus/agent/belongmode'"><el-input clearable v-model="formInline.belong_id" placeholder="归属ID" style="width:120px"></el-input></el-form-item>
            <el-form-item label="昵称或手机"><el-input clearable v-model="formInline.nick_name" placeholder="请输入昵称或手机" style=""></el-input></el-form-item>
            <el-form-item label="会员等级">
              <el-select v-model="formInline.grade_id" placeholder="请选择">
                <el-option label="全部" value="0"></el-option>
                <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="地区">
              <el-select v-model="formInline.province_id" placeholder="省" @change="initCity" clearable>
                <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
              </el-select>
              <el-select v-if="formInline.province_id!=''" v-model="formInline.city_id" placeholder="市" @change="initRegion" clearable>
                <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[formInline.province_id]['city']"
                  :key='index1'></el-option>
              </el-select>
              <el-select v-if="formInline.city_id!=''" v-model="formInline.region_id" placeholder="区" clearable>
                <el-option :label="item2.name" :value="item2.id" v-for="(item2,index2) in areaList[formInline.province_id]['city'][formInline.city_id]['region']"
                  :key='index2'></el-option>
              </el-select>

            </el-form-item>
            <el-form-item label="备注">
            <el-select size="small" v-model="formInline.is_remark" clearable placeholder="请选择">
              <el-option label="全部" value="0"></el-option>
              <el-option label="无内容" value="1"></el-option>
              <el-option label="有内容" value="2"></el-option>
             
            </el-select>
          </el-form-item>
        </div>
        <!-- <el-form-item label="团长ID"><el-input v-model="formInline.top_user_id" placeholder="用户ID" style="width:120px"></el-input></el-form-item> -->
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.reg_date" type="daterange"  value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onExport">导出</el-button></el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @sort-change="sortChange">
          <el-table-column prop="user_id" label="ID" width="80" sortable="custom"></el-table-column>
          <el-table-column prop="nickName" label="用户" width="300">
            <template slot-scope="scope">
              <div class="d-s-c">
                <img v-img-url="scope.row.avatarUrl" width="60px" height="60px" />
                <div class="ml10">
                  <p class="f14 fb">{{ scope.row.nickName }} <el-tag type="info" class="style1-tag">{{ scope.row.grade.name }}</el-tag></p>
                  <p class="gray3" v-if="scope.row.mobile">手机：{{ scope.row.mobile }}</p>
                  <!-- <p class="gray9">性别：{{ scope.row.gender | convertSex }}</p> -->
                  <!-- <p class="gray9" v-if="scope.row.referee_id">推荐人ID：{{ scope.row.referee_id }}</p> -->
                  <p class="gray9" v-if="scope.row.referee_id && scope.row.user_referee!=null">
                    推荐人：{{ scope.row.user_referee.nickName }} [<span class="golden">{{ grade[scope.row.user_referee.grade_id].name }}</span>] 
                  </p>
                  <p class="gray9" v-if="scope.row.belong_id && belongmode">归属上级ID：{{ scope.row.belong_id }}</p>
                   <p class="gray9" v-if="scope.row.open_id">
                    小程序OpenID：【{{ scope.row.open_id }}】
                    
                  </p>
                  <p class="gray9" v-if="scope.row.region">
                    {{scope.row.region.province}} {{scope.row.region.city}} {{scope.row.region.region}}
                  </p>
                  <p class="gray9" v-if="scope.row.birthday">
                    生日：{{scope.row.birthday}}
                  </p>
                  <p class="gray9">
                    <span v-if="scope.row.height">身高：{{scope.row.height}}</span>
                    <span v-if="scope.row.weight">体重：{{scope.row.weight}}</span>
                    <span v-if="scope.row.shoe_size">鞋码：{{scope.row.shoe_size}}</span>
                  </p>
                  <p v-if="scope.row.addressDefault">
                    默认收货地址：{{ scope.row.addressDefault.region.province }} {{ scope.row.addressDefault.region.city }} {{ scope.row.addressDefault.region.region }}  {{ scope.row.addressDefault.detail }} 
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="grade.name" label="等级/消费" width="150">
            <template slot-scope="scope">
             <p>{{ scope.row.grade.name }}</p>
             <p>累计消费：{{ scope.row.order_total_money }}</p>
             <p>当年消费：{{ scope.row.order_year_money }}</p>
             <p>累计积分：{{ scope.row.total_points }}</p>
             <p>当年积分：{{ scope.row.total_year_points }}</p>
            </template>
            
          </el-table-column>
          <el-table-column prop="plantform_id" label="平台" width="150" v-if="show_plantform">
            <template slot-scope="scope">
              <div class="d-s-c">
                <div v-if="scope.row.plantform">
                   <p class="">
                      <el-tag type=""  class="style1-tag">{{scope.row.plantform.name}}</el-tag>
                    </p>
                    <p class="">平台昵称：{{scope.row.plantform_nickname}}</p>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="labels" label="标签" v-if="show_labels">
            <template slot-scope="scope">
              <div class="d-s-c">
                <div v-if="scope.row.plantform">
                    <el-tag size="mini" class="style1-tagb ml10" v-for="item in scope.row.labels" :key="item.label_id">{{item.name}}</el-tag>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="" label="备注" width="150" v-if="show_remark">
            <template slot-scope="scope">
              <div class="d-s-c">
                <div v-if="scope.row.last_reamrk">
                    {{scope.row.last_reamrk}}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="agentBoss" label="2+1代理关系" width="300" v-if="agent_boss">
            <template slot-scope="scope">
              <div class="d-s-c">
                <div v-if="scope.row.agentBoss">
                   <p class="gray9">
                      <el-tag type="danger"  class="style1-tag">{{scope.row.agentBoss.is_boss?'老板':'代理'}}</el-tag>
                    </p>
                    <p class="gray9">代理邀请人ID：{{scope.row.agentBoss.agentid }}</p>
                    <p class="gray9">
                      归属老板：{{ scope.row.agentBoss.boss_id }}
                    </p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="points" label="积分" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="balance" label="余额" sortable="custom" align="center"></el-table-column>
          <el-table-column prop="goods_balance" label="返利" sortable="custom" align="center"></el-table-column>
          <!-- <el-table-column prop="invite_code" label="邀请码" sortable="custom" align="center"></el-table-column> -->
          <el-table-column prop="referees_count" label="直推人数" sortable="custom" align="center" v-if="show_agent">
            <template slot-scope="scope">
              <span @click="gotoPage('/user/structure/index', {user_id:scope.row.user_id})">{{ scope.row.referees_count }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="agent_log_sum" label="佣金" sortable="custom" align="center" v-if="show_agent">
            <template slot-scope="scope">
              <span @click="gotoPage('/user/agent/index', {user_id:scope.row.user_id})">{{ scope.row.agent_log_sum }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="province" label="省市">
            <template slot-scope="scope">
              {{ scope.row.province + scope.row.city }}
            </template>
          </el-table-column> -->
          <el-table-column prop="create_time" label="注册时间" width="140" sortable="custom"></el-table-column>
          <el-table-column fixed="right" label="操作" width="160">
            <template slot-scope="scope">
              <el-button @click="addRemark(scope.row)" type="text" v-auth="'/user/remark/index'" size="small">用户备注</el-button>
              <el-button @click="gotoPage('/user/agent/index', {user_id:scope.row.user_id})" type="text" size="small" v-auth="'/user/agent/index'" href="/" target="_blank">佣金明细</el-button>
              <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/user/user/recharge'">充值</el-button>
              <el-button @click="editAgentboss(scope.row)" type="text" size="small" v-auth="'/user/user/editAgent'">代理老板设置</el-button>
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/user/user/grade'">详情</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[20, 50, 100, 200, 300, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!--会员充值-->
    <Recharge v-if="open_add" :open_add="open_add" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'add')"></Recharge>

    <!--会员等级-->
    <Grade v-if="open_edit" :open_edit="open_edit" :form="userModel" :gradeList="gradeList" :labelList="labelList" :plantformList="plantformList" :hobbyList="hobbyList" :jobList="jobList" @closeDialog="closeDialogFunc($event, 'edit')"></Grade>
     <!--2+1代理老板设置-->
    <Agentboss v-if="open_agentboss" :open_agentboss="open_agentboss" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'agentboss')"></Agentboss>
    <UserRemark v-if="open_remark" :open_remark="open_remark" :form="userModel" @closeDialog="closeDialogFunc($event, 'reamrk')"></UserRemark>

  </div>
</template>

<script>
import DataApi from '@/api/data.js';
import UserApi from '@/api/user.js';
import Grade from './dialog/Grade.vue';
import Recharge from './dialog/Recharge.vue';
import Agentboss from './dialog/Agentboss.vue';
import UserRemark from './dialog/UserRemark.vue';
import qs from 'qs';
export default {
  components: {
    /*编辑组件*/
    Agentboss,
    UserRemark,
    Grade,
    Recharge
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        nick_name: '',
        grade_id: '',
        user_id: '',
        is_remark: '',
        distributor_id: '',
        reg_date: '',
        top_user_id:'',
        belong_id:'',
        referee_id:'',
        province_id:'',
        city_id:'',
        region_id:'',
        plantform_id:'',
        job_id:'',
        hobby_id:'',
        label_id:'',
      },
      /*是否打开添加弹窗*/
      open_add: false,
      open_remark: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      open_agentboss: false,
      /*当前编辑的对象*/
      userModel: {},
      /*等级*/
      gradeList: [],
      grade: [],
      agent_boss:false,
      belongmode:false,
      show_plantform:false,
      show_labels:false,
      show_agent:false,
      show_remark:false,
      areaList:[],
      plantformList:[],
      labelList:[],
      hobbyList:[],
      jobList:[],
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
    this.getAreas();
    this.getPlantform();
    this.getLabel();
    this.getHobby();
    this.getJob();
    if(this.$filter.isAuth('/user/user/editAgent')) this.agent_boss = true;
    if(this.$filter.isAuth('/plus/agent/belongmode')) this.belongmode = true;
    if(this.$filter.isAuth('/user/plantform/index')) this.show_plantform = true;
    if(this.$filter.isAuth('/user/label/index')) this.show_labels = true;
    if(this.$filter.isAuth('/plus/agent/index')) this.show_agent = true;
    if(this.$filter.isAuth('/user/remark/index')) this.show_remark = true;
  },
  methods: {
      // 获取区域
      getAreas(){
        let self = this;
        DataApi.getArea({}, true)
          .then(res => {
            self.areaList = res.data.regionData;
          })
          .catch(error => {});
      },
      // 获取平台
      getPlantform(){
        let self = this;
        DataApi.getPlantform({}, true)
          .then(res => {
            self.plantformList = res.data.list;
          })
          .catch(error => {});
      },
      // 获取职业
      getJob(){
        let self = this;
        DataApi.getJob({}, true)
          .then(res => {
            self.jobList = res.data.list;
          })
          .catch(error => {});
      },
      // 获取标签
      getLabel(){
        let self = this;
        DataApi.getLabel({}, true)
          .then(res => {
            self.labelList = res.data.list;
          })
          .catch(error => {});
      },
      // 获取爱好
      getHobby(){
        let self = this;
        DataApi.getHobby({}, true)
          .then(res => {
            self.hobbyList = res.data.list;
          })
          .catch(error => {});
      },
      /*初始化城市id*/
      initCity() {
        this.formInline.city_id = ''
        this.formInline.region_id = ''
      },

      /*初始化区id*/
      initRegion() {
        this.formInline.region_id = ''
      },
    /*跳转页面*/
    gotoPage(path, query) {
      this.$router.push({
        path: path,
        query: query
      });
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      Params.sort_name = self.sortName;
      Params.sort_value = self.sortValue;
      UserApi.userlist(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
          self.gradeList = data.data.grade;
          data.data.grade.forEach((v,i) => {
            self.grade[v.grade_id] = v
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.loading = true;
      this.curPage = 1;
      this.getTableList();
    },

    /*排序查询*/
    sortChange(e){
      if (e.order && e.order != null){
        this.sortName = e.prop;
        this.sortValue = e.order=='ascending' ? 'asc' : 'desc';
      }else{
        this.sortName = this.sortValue = '';
      }
      this.tableData = [];
      this.getTableList();
    },

    /*打开添加*/
    addClick(item) {
      this.userModel = item;
      this.open_add = true;
    },
    /*打开添加*/
    addRemark(item) {
      this.userModel = item;
      this.open_remark = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },
     /*打开编辑*/
    editAgentboss(item) {
      this.userModel = item;
      this.open_agentboss = true;
    },
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/user.user/export?' + qs.stringify(this.formInline);
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      this.open_remark = false;
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'agentboss') {
        this.open_agentboss = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true;
          UserApi.deleteuser(
            {
              user_id: row.user_id
            },
            true
          )
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，用户删除成功',
                  type: 'success'
                });
                self.getTableList();
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        })
        .catch(() => {
          self.loading = false;
        });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/user/index.vue